import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";

export function logError(msg) {
  return (exception) => {
    showError(msg);
    console.error(msg, exception);
    Sentry.captureException(exception);
  };
}

export function showError(msg) {
  console.log(msg);
  const text = msg.message ? msg.message : msg;
  // toastId = text dedups identical errors: a flaky endpoint firing the same
  // "Fehler beim Laden der Daten" on every retry now shows one toast, not a
  // stack of them (review #39).
  toast.error(text, { toastId: text });
}

export function showSuccess(msg) {
  console.log(msg);
  toast.success(msg);
}

export function notifyResult(promise) {
  return promise
    .then((msg) => showSuccess(msg.message))
    .catch((err) => {
      showError(err.message);
      throw err;
    });
}
